import * as React from 'react'

import { CounselingCard as Presenter, IProps } from './presenter'

export const CounselingCard = ({
  catchcopy,
  specialtyConsultations,
  pricePerMinute,
  reviewScore,
  reviewCount,
  imageUrl,
  showUrl,
  editUrl,
  progressCounseling,
  nowStatus,
  certs,
  certsIncludeTraining,
}: IProps): JSX.Element => {
  return (
    <Presenter
      catchcopy={catchcopy}
      specialtyConsultations={specialtyConsultations}
      pricePerMinute={pricePerMinute}
      reviewScore={reviewScore}
      reviewCount={reviewCount}
      imageUrl={imageUrl}
      showUrl={showUrl}
      editUrl={editUrl}
      progressCounseling={progressCounseling}
      nowStatus={nowStatus}
      certs={certs}
      certsIncludeTraining={certsIncludeTraining}
    />
  )
}

export default CounselingCard
